export default [
  {
    path: "/phone",
    component: (resolve) => require(["@/vuepage/operation-manage/phone/index.vue"], resolve),
    meta: [
      {
        name: "营运管理",
      },
      {
        name: "手机号管理",
        activeRoute: "/phone",
      },
    ],
  },
  {
    path: "/swiper",
    component: (resolve) => require(["@/vuepage/operation-manage/swiper/index.vue"], resolve),
    meta: [
      {
        name: "营运管理",
      },
      {
        name: "轮播图管理",
        activeRoute: "/swiper",
      },
    ],
  },
  {
    path: "/swiper-add",
    component: (resolve) => require(["@/vuepage/operation-manage/swiper/add.vue"], resolve),
    meta: [
      {
        name: "营运管理",
      },
      {
        name: "新增轮播图",
        activeRoute: "/swiper",
      },
    ],
  },
  {
    path: "/coupon",
    component: (resolve) => require(["@/vuepage/operation-manage/coupon/index.vue"], resolve),
    meta: [
      {
        name: "营运管理",
      },
      {
        name: "优惠券管理",
        activeRoute: "/coupon",
      },
    ],
  },
  {
    path: "/coupon-add",
    component: (resolve) => require(["@/vuepage/operation-manage/coupon/add.vue"], resolve),
    meta: [
      {
        name: "营运管理",
      },
      {
        name: "新增优惠券",
        activeRoute: "/coupon",
      },
    ],
  },
  {
    path: "/school-style",
    component: (resolve) => require(["@/vuepage/operation-manage/school/index.vue"], resolve),
    meta: [
      {
        name: "营运管理",
      },
      {
        name: "学校风采",
        activeRoute: "/school-style",
      },
    ],
  },
  {
    path: "/add-school-style",
    component: (resolve) => require(["@/vuepage/operation-manage/school/add.vue"], resolve),
    meta: [
      {
        name: "营运管理",
      },
      {
        name: "新增学校风采",
        activeRoute: "/school-style",
      },
    ],
  },
  {
    path: "/student-style",
    component: (resolve) => require(["@/vuepage/operation-manage/student/index.vue"], resolve),
    meta: [
      {
        name: "营运管理",
      },
      {
        name: "学员风采",
        activeRoute: "/student-style",
      },
    ],
  },
  {
    path: "/student-style-add",
    component: (resolve) => require(["@/vuepage/operation-manage/student/add.vue"], resolve),
    meta: [
      {
        name: "营运管理",
      },
      {
        name: "新增学员风采",
        activeRoute: "/student-style",
      },
    ],
  },
  {
    path: "/classification",
    component: (resolve) => require(["@/vuepage/operation-manage/classification.vue"], resolve),
    meta: [
      {
        name: "营运管理",
      },
      {
        name: "分类管理",
        activeRoute: "/classification",
      },
    ],
  },
];
